export enum OrderState {
    pending,
    paid,
    shipped,
    delivered,
    cancelled
}

export interface OrderBill {
    id: string;
    number: string;
    date: string;
    value: number;
    file: string;
}

// #TODO: check if needed after changes to EditDeliveryModal
export interface OrderDelivery {
    id: string;
    address: string;
    option: { value: string; text: string };
}

export interface OrderPayment {
    total: number;
    name: string;
    method: string;
    multibancoEntity?: string;
    multibancoReference?: string;
    phoneNumber?: string;
    cardNumber?: string;
}

export interface OrderLog {
    id: string;
    date: string;
    amount?: string;
    notes: string;
    store?: string;
}

export type OrderDeliveryKeys = 'locker' | 'shipToPickupSpot' | 'pickupAtStore' | 'shipToAddress';
